interface SortExtends {
  title: string;
  name: string;
  createdAt: number;
  updatedAt: number;
}

export function getSortFn<T extends Partial<SortExtends>>(by: keyof T, order: 'ASC' | 'DESC'): (a: T, b: T) => number {
  const sort = (a: T, b: T): number => {
    if (a[by] === undefined || b[by] === undefined) return 0;
    if (a[by] === b[by]) {
      return 0;
    }
    if (typeof a[by] === 'string') {
      const aStr = a[by] + '';
      const bStr = b[by] + '';
      return aStr.toLowerCase() > bStr.toLowerCase() ? (order === 'ASC' ? 1 : -1) : order === 'ASC' ? -1 : 1;
    }

    return a[by] > b[by] ? (order === 'ASC' ? 1 : -1) : order === 'ASC' ? -1 : 1;
  };

  return sort;
}
